import { get, getResultFromResponse } from './request';
import { isRunAsSubApp } from './wujie';
import { UserInfo, Chain } from '../types';

const mock = {
  id: 3822097,
  username: '',
  country_code: '',
  status: 'Normal',
  email_verified: true,
  mobile_verified: false,
  avatar: '',
  auto_add_margin: false,
  currency_code: '',
  created_at: '2024-05-27 18:49:36',
  vague_mobile: '',
  vague_email: 'miller.zhou0103@gmail.com',
  vague_email_v2: 'mil***@****',
  has_google2fa: false,
  lang: 'en',
  use_ws2: false,
  use_svc_order: true,
  use_order_v2: true,
  double_confirm:
    'positionConfirm,obAnimation,orderConfirm,hidePhoneConfirm,cancelAllConfirm',
  use_ws2_for_personal: true,
  use_webworker: true,
  msg_disable_module_ids: '',
  ws3_path: 'realtime_private_7_10',
  account_label: null,
  is_submember: false,
  parent_member_id: 0,
  submember_gray_allow: true,
  member_tag: {
    change_utc_time_zone: '24',
    registered_member_type: 'derivatives',
  },
  credit_card_deposit_gray: {
    APP: false,
    OnRamp: true,
    Paxful: true,
    Simplex: true,
  },
  ref_id: 3900644420,
  parent_verify_method: '',
  of_affiliate_user: false,
  is_wallet_gray_user: true,
  banStatus: {
    login: 1,
    trade: 1,
    withdraw: 1,
    trade_banned_detail: {
      future: {},
      spot: {
        type: [1],
      },
      unified: {},
      fiat: {
        platform_credit_card: {},
        p2p: {},
        third_party_payment_channel: {},
      },
    },
    is_normal: true,
    withdraw_ban_detail: {},
  },
  is_deposit: false,
  option_gray: true,
  asset_gray: true,
  mv_php_gray: true,
  lb_exchange_gray: true,
  usdc_linear_gray: true,
  has_mt4: false,
  is_bot_user: false,
  is_copy_trading_leader: false,
  is_copy_trading_follower: false,
  fullPositionStatus: 'I',
  isFiat: true,
  unified_account: 0,
  platform: 'pc',
  grayFlag: {
    IsFA: true,
    'IsFA-Earn': false,
    IsInternalTransfer: true,
    IsP2P: false,
    IsUTA: true,
    IsUTASpotClose: true,
    fiatConvert: true,
    fundingBlockTradeConvert: true,
    isBlockTradeConvert: true,
    isFundingConvert: true,
    isInternalSecureComponent: true,
    isSecureComponent: true,
    isSpotConvert: true,
    spotBlockTradeConvert: true,
    test11: false,
    utaBlockTradeConvert: true,
    utaConvert: true,
    utaSmallAsset: true,
  },
  hid: 'z5P92X',
  kyc_person_level: 0,
  client_ip: '10.18.4.133',
  client_country: '',
  risk: 0,
  demo_id: 0,
};

export const getUserInfo = async () => {
  if (isRunAsSubApp) {
    // @ts-ignore
    return window.$wujie?.props?.getUserInfo() as UserInfo;
  }
  return getResultFromResponse(
    get<UserInfo>('/v2/private/user/profile', {
      withCredentials: true,
    })
  );
};

/** 获取链列表 */
export const queryChainList = () => {
  return get<{
    walletChains: {
      CLOUD: { itemList: Chain[] };
      MNEMONIC_PHRASE: { itemList: Chain[] };
      MPC: {
        itemList: Chain[];
      };
    };
  }>('/web3/wallet/v1/private/mgmt/chain/list');
};

export const getCloudWalletList = async () => {
  if (isRunAsSubApp) {
    // @ts-ignore
    return window.$wujie?.props?.getCloudWalletList();
  }
};

export const getCurrentWallet = async () => {
  if (isRunAsSubApp) {
    // @ts-ignore
    return window.$wujie?.props?.getCurrentWallet();
  }
};

export const getChains = async () => {
  if (isRunAsSubApp) {
    // @ts-ignore
    return window.$wujie?.props?.getChains();
  }
};
